import { useAppSelector, useAppDispatch } from 'hooks';

import { Text, SimpleGrid, Box } from '@chakra-ui/react';

import Card from 'components/card/Card';

import FormInput from 'components/fields/home/FormInput';

import { changeCrossReferences } from 'reducers/homePersonalFormReducer';

import { SECTIONS } from 'views/home_form/constants';

const CrossReferenceInformation = () => {
  const dispatch = useAppDispatch();

  const data = useAppSelector(
    (state) => state.homePersonalForm.data?.cross_reference_information,
  );

  const onCrossReferenceChange = (event: any, index: number) => {
    const { name, value, checked, type } = event.target;
    const payload = type === 'checkbox' ? checked : value;

    dispatch(changeCrossReferences({ index, name, value: payload }));
  };

  if (!data) return null;

  return (
    <Card mb="20px" id="sectionCrossReferenceInformation">
      <Text fontWeight="bold" fontSize="2xl" mb="20px">
        Cross Reference Information
      </Text>

      {data && data.length > 0 ? (
        <>
          {Array.from({ length: Math.ceil(data.length / 4) }, (_, rowIndex) => (
            <SimpleGrid
              key={rowIndex}
              templateColumns="repeat(4, 1fr)"
              spacing="20px"
            >
              {data
                .slice(rowIndex * 4, rowIndex * 4 + 4)
                .map((crossRef, colIndex) => {
                  const index = rowIndex * 4 + colIndex;
                  return (
                    <Box key={index}>
                      <Text
                        fontWeight="medium"
                        fontSize="sm"
                        mb="10px"
                        textAlign="center"
                      >
                        Policy {index + 1}
                      </Text>
                      <Box>
                        <FormInput
                          section={SECTIONS.CROSS_REFERENCE_INFORMATION}
                          label="Line of Business"
                          name="line_of_business"
                          value={crossRef.line_of_business || ''}
                          onChange={(event: any) =>
                            onCrossReferenceChange(event, index)
                          }
                        />
                        <Box mt="10px">
                          <FormInput
                            section={SECTIONS.CROSS_REFERENCE_INFORMATION}
                            label="Policy Number"
                            name="policy_number"
                            value={crossRef.policy_number || ''}
                            onChange={(event: any) =>
                              onCrossReferenceChange(event, index)
                            }
                          />
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
            </SimpleGrid>
          ))}
        </>
      ) : (
        <Text
          fontSize="md"
          color="gray.600"
          fontStyle="italic"
          textAlign="center"
        >
          No cross reference information available
        </Text>
      )}
    </Card>
  );
};

export default CrossReferenceInformation;
